import confetti from 'canvas-confetti';

const CELEBRATION_PENDING_KEY = 'practium:paymentCelebrationPending';

export function markPaymentCelebrationPending() {
	sessionStorage.setItem(CELEBRATION_PENDING_KEY, '1');
}

export function consumePaymentCelebrationPending(): boolean {
	const pending = sessionStorage.getItem(CELEBRATION_PENDING_KEY) === '1';
	if (pending) sessionStorage.removeItem(CELEBRATION_PENDING_KEY);
	return pending;
}

export function fireSuccessConfetti() {
	if (globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

	const options = { zIndex: 2000, disableForReducedMotion: true };

	confetti({ ...options, particleCount: 120, spread: 90, origin: { y: 0.3 } });
	confetti({ ...options, particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.5 } });
	confetti({ ...options, particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.5 } });
}
